export const ACCEPTING_LOAD_TRIP_STATUS = "accepting_load";

export const ACTIVE_TRIP_STATUSES = [
  "accepting_load",
  "planned",
  "loaded",
  "en_route",
];

/** In-progress trips shown under the Active Trips scope tab (excludes planned/upcoming). */
export const IN_PROGRESS_TRIP_STATUSES = ["loaded", "en_route"];

/** Planned / upcoming scope: open shared loads and scheduled departures. */
export const PLANNED_SCOPE_STATUSES = ["accepting_load", "planned"];

export const PLANNED_TRIP_STATUS = "planned";

export const ARCHIVED_TRIP_STATUS = "completed";

export const TRIP_STATUS_LABELS = {
  accepting_load: "Accepting load",
  planned: "Planned",
  loaded: "Loaded",
  en_route: "En Route",
  completed: "Completed",
};

/** Linear ops lifecycle — must match backend tripStatuses.js */
export const TRIP_STATUS_TRANSITIONS = {
  accepting_load: ["planned"],
  planned: ["loaded"],
  loaded: ["en_route"],
  en_route: ["completed"],
  completed: [],
};

/** Next status in the ops workflow, or null when terminal / use Schedule departure. */
export function getNextTripStatus(currentStatus) {
  const next = TRIP_STATUS_TRANSITIONS[currentStatus];
  return next?.[0] ?? null;
}

/** Primary action label for advancing to the next status. */
export const ADVANCE_TRIP_STATUS_LABELS = {
  loaded: "Mark as loaded",
  en_route: "Mark en route",
  completed: "Mark completed",
};

/** Statuses where orders can be linked to a trip (when bookingOpen). */
export const LINKABLE_TRIP_STATUSES = new Set([
  "accepting_load",
  "planned",
  "loaded",
  "en_route",
]);
